import React from "react";

const Size_of_an_Array = () => {
  return (
    <div>
      <h1>Size_of_an_Array Component</h1>
      <p>Content for Size_of_an_Array goes here...</p>
    </div>
  );
};

export default Size_of_an_Array;
